module.exports = __webpack_public_path__ + "static/media/gov-site-ccs.fb1fc37a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/providers-registrations/onboarding/views/gov-site-ccs.svg
// module id = 1043
// module chunks = 0